module.exports = __webpack_public_path__ + "static/media/DSC_0190(1).08accf5b.jpg";